"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m11.2933 16.5964 4.9498-4.9498c1.9526-1.9526 1.9526-5.1184 0-7.071l-3.1816-3.1822L9.5259 4.929l3.1819 3.182-4.9497 4.9498c-1.9526 1.9526-1.9526 5.1184 0 7.071l2.4749 2.4749 3.5357-3.5356-2.4754-2.4747zm-1.0604 1.7679-.3538-.3537c-.781-.7811-.781-2.0474 0-2.8285l4.9497-4.9497c1.1716-1.1716 1.1716-3.071 0-4.2427l-1.0605-1.0605-.7069.707 1.0606 1.0606c.7811.781.7811 2.0474 0 2.8284L9.1723 14.475c-1.1716 1.1716-1.1716 3.071 0 4.2426l.3537.3537.7069-.707z"
  })];
};

exports.default = _default;